module.exports = __webpack_public_path__ + "static/media/irregularTriangle1.840a523b.svg";